var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResetForm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14.831,
  height: 14.238,
  viewBox: "-13041.411 1937.885 14.831 14.238"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10801"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10800",
  transform: "translate(-13046 1933)",
  clipPath: "url(\"#a\")"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 280430"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.996 16.452h-1.738c2.459-3.053 1.95-7.548-1.103-10.007-3.053-2.46-7.547-1.95-10.007 1.103-2.459 3.053-1.95 7.547 1.103 10.006a7.127 7.127 0 0 0 4.452 1.57c.254 0 .424-.17.424-.425 0-.254-.17-.424-.424-.424a6.235 6.235 0 0 1-6.318-6.233 6.235 6.235 0 0 1 6.233-6.318 6.235 6.235 0 0 1 6.318 6.233c0 1.57-.551 3.053-1.569 4.198v-2.332c0-.254-.17-.424-.424-.424s-.424.17-.424.424v3.053c0 .254.17.424.424.424h3.053c.255 0 .424-.17.424-.424a.425.425 0 0 0-.424-.424",
  fill: "#26890d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 16.452h-1.738c2.459-3.053 1.95-7.548-1.103-10.007-3.053-2.46-7.547-1.95-10.007 1.103-2.459 3.053-1.95 7.547 1.103 10.006a7.127 7.127 0 0 0 4.452 1.57c.254 0 .424-.17.424-.425 0-.254-.17-.424-.424-.424a6.235 6.235 0 0 1-6.318-6.233 6.235 6.235 0 0 1 6.233-6.318 6.235 6.235 0 0 1 6.318 6.233c0 1.57-.551 3.053-1.569 4.198v-2.332c0-.254-.17-.424-.424-.424s-.424.17-.424.424v3.053c0 .254.17.424.424.424h3.053c.255 0 .424-.17.424-.424a.425.425 0 0 0-.424-.424",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 0.5,
  stroke: "#26890d",
  fill: "transparent"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24.042H0V0z",
  "data-name": "Rectangle 5568"
})))));
export default SvgResetForm;